module.exports = __webpack_public_path__ + "img/button_round_medium_underlay.545727f3.png";